
const registrationInboxes = [
    {
        "uuid":"1",
        "activityId":"S10",
        "customer":"源天然股份有限公司",
        "assessmentPlace":"台東廠/ 屏東廠",
        "estimatedProductNumber":5,
        "standardTseYue":true,
        "standardLeezen":true,
        "createdOn":"2021-03-12T08:20:10.000Z",
        "formUuid":"1"
    },
    {
        "uuid":"2",
        "activityId":"S10",
        "customer":"豆之家食品科技股份有限公司",
        "assessmentPlace":"桃園廠",
        "estimatedProductNumber":15,
        "standardTseYue":true,
        "standardLeezen":false,
        "createdOn":"2021-03-21T08:20:10.000Z",
        "formUuid":"2"
    }
]

export default registrationInboxes;